import React from 'react';
import Box from '../Box/Box';
import { TertiaryButton } from '../Button';
import ButtonIcon from '../Button/ButtonIcon';

type TUploadTrigger = {
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  className?: string;
  tabIndex?: number;
  uploadImageLabel: string;
  ariaLabel: string;
  aspectRatio?: 'landscape' | 'portrait' | 'square';
};
const UploadTrigger = ({
  className = '',
  tabIndex,
  fileInputRef,
  uploadImageLabel,
  ariaLabel,
  aspectRatio = 'square',
}: TUploadTrigger) => {
  const aspectRatioClass = aspectRatio ? `hz-Image--${aspectRatio}` : '';
  const combinedClassName = `${className || ''} ${aspectRatioClass}`.trim();
  return (
    <Box as="div" name="Image" className={`hz-Image--add-photo ${combinedClassName}`}>
      <TertiaryButton
        onClick={() => fileInputRef.current?.click()}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
        type="button"
      >
        <ButtonIcon name="add-image" />
        {uploadImageLabel}
      </TertiaryButton>
    </Box>
  );
};

export default UploadTrigger;
